import { memo } from "react";
import Rotate from "./Rotate";
import { cn } from "@/shared/utils/cn";

const Container = ({
  className,
  children,
}: {
  className: string;
  children: React.ReactNode;
}) => (
  <div
    className={cn(
      "[&>div]:h-16 [&>div]:border [&>div]:border-black [&>div]:bg-white [&>div]:p-4 [&>div]:items-center [&>div:nth-child(2)]:border-x-0 [&>div:not(:nth-child(2))]:transition-all [&>div:not(:nth-child(2))]:hover:bg-[#cccccc] [&_input]:pointer-events-none [&_input]:select-none [&_input]:border-none [&_input]:text-center [&_input]:w-10",
      className
    )}
  >
    {children}
  </div>
);

interface TablePaginationProps {
  value: number;
  onNextClick: () => void;
  onPrevClick: () => void;
  nextDisabled?: boolean;
  dynamicPrevDisabled?: boolean;
  dynamicLabel?: string;
}

const TablePagination = ({
  value = 1,
  onNextClick,
  onPrevClick,
  nextDisabled = false,
  dynamicPrevDisabled = undefined,
  dynamicLabel,
}: TablePaginationProps) => {
  const prevDisabled =
    dynamicPrevDisabled !== undefined ? dynamicPrevDisabled : value === 1;
  return (
    <Container className="flex items-center">
      <div
        onClick={prevDisabled ? undefined : onPrevClick}
        className="cursor-pointer"
        style={{ pointerEvents: prevDisabled ? "none" : "unset" }}
      >
        <div style={{ opacity: prevDisabled ? 0.2 : 1 }}>
          <Rotate degrees={`90deg`} size="2rem" fill="black" variants="arrow" />
        </div>
      </div>
      <div>
        <input
          className="bg-white text-black"
          style={{
            width: dynamicLabel ? "14rem" : undefined,
          }}
          value={dynamicLabel || value}
          readOnly
        />
      </div>
      <div
        onClick={nextDisabled ? undefined : onNextClick}
        className="cursor-pointer"
        style={{ pointerEvents: nextDisabled ? "none" : "unset" }}
      >
        <div style={{ opacity: nextDisabled ? 0.2 : 1 }}>
          <Rotate
            degrees={`-90deg`}
            size="2rem"
            fill="black"
            variants="arrow"
          />
        </div>
      </div>
    </Container>
  );
};

export default memo(TablePagination);
